import { Component, input } from '@angular/core';

@Component({
  selector: 'app-pan-section-header',
  templateUrl: './pan-section-header.component.html',
  styleUrl: './pan-section-header.component.scss',
  standalone: false,
})
export class PanSectionHeaderComponent {
  public title = input.required<string>();
}
